import React from "react";
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import RunZeroCredentialsForm from "./RunZeroCredentialsForm";
import RunZeroConfigListing from "./RunZeroConfigListing";

export default function RunZeroPullAndPushView(props){
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={RunZeroCredentialsForm}
            PullConfigListingView={RunZeroConfigListing}
        />
    )
}